import { useEffect } from 'react'

import {
  getClinicIdFromStorage,
  getUserIdFromStorage,
} from '../../helpers/storageAccess'
import {
  useAuthContextData,
  useAuthContext,
  useClinicContext,
} from '../../hooks'

export const useStorageCheck = (routeClinicId: number | null | undefined) => {
  const { userId } = useAuthContextData()
  const { clinicId, setClinicId } = useClinicContext()
  const { contextStore } = useAuthContext()

  useEffect(() => {
    const storageUserId = contextStore.getUserId()

    if (userId && !storageUserId) {
      contextStore.setUserId(userId)
    }

    if (!userId && !storageUserId) {
      contextStore.setUserId(getUserIdFromStorage())
    }
  }, [userId, contextStore])

  useEffect(() => {
    const storageClinicId = Number(getClinicIdFromStorage(userId))

    if (!clinicId && storageClinicId) {
      setClinicId(storageClinicId)
    }
  }, [clinicId, contextStore, userId, setClinicId])

  useEffect(() => {
    if (routeClinicId && routeClinicId !== clinicId) {
      setClinicId(routeClinicId)
    }
  }, [clinicId, routeClinicId, setClinicId])
}
